export const formatEnumToLabel = (enumValue: string): string =>
  enumValue
    .split('_')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
